<template>
  <div>
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6"></div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12">
            <div class="card card-success">
              <div class="card-header">
                <h3 class="card-title">Gift Card Issuance Report</h3>
              </div>
              <div class="loading" v-if="loading">
                <hour-glass></hour-glass>
              </div>
              <div class="card-body">
                <!-- Store Selection and Date Range Filter -->
                <div class="row mb-3">
                  <div class="col-md-3">
                    <div class="form-group">
                      <label for="storeSelect">Select Store:</label>
                      <multiselect
                        id="storeSelect"
                        v-model="selectedStore"
                        :options="storeList"
                        :searchable="true"
                        :show-labels="false"
                        label="retailer"
                        track-by="id"
                        placeholder="Select store"
                        @input="onStoreSelect"
                      ></multiselect>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label for="fromDate">From Date:</label>
                      <input
                        type="date"
                        id="fromDate"
                        class="form-control"
                        v-model="filters.fromDate"
                        :max="filters.toDate"
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label for="toDate">To Date:</label>
                      <input
                        type="date"
                        id="toDate"
                        class="form-control"
                        v-model="filters.toDate"
                        :min="filters.fromDate"
                        :max="today"
                      />
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group">
                      <label>&nbsp;</label>
                      <b-button
                        variant="success"
                        @click="reloadDatatable"
                        :disabled="loading || !selectedStore || !isDateRangeValid()"
                        class="btn-block"
                      >
                        <i class="fas fa-search"></i> Generate Report
                      </b-button>
                    </div>
                  </div>
                </div>

                <!-- Issuance Report Table -->
                <div class="card-body table-responsive" v-if="selectedStore">
                  <table
                    id="giftCardIssuanceTable"
                    class="table table-striped table-bordered"
                    style="width: 100%; white-space: normal"
                  >
                    <thead>
                      <tr>
                        <th>Date</th>
                        <th>Store</th>
                        <th>Type</th>
                        <th>Reference Number</th>
                        <th>Sender's Name</th>
                        <th>Consumer</th>
                        <th>Phone</th>
                        <th>Email</th>
                        <th>Amount</th>
                        <th>Delivery Date</th>
                        <th>Message</th>
                      </tr>
                    </thead>
                    <tbody></tbody>
                  </table>
                </div>

                <!-- No Store Selected Message -->
                <div class="row" v-if="!selectedStore">
                  <div class="col-md-12">
                    <div class="alert alert-info">
                      <i class="fas fa-info-circle"></i> Please select a store to view gift card issuance details.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- Message Display Modal -->
    <b-modal
      id="message-display-modal"
      ref="message-display-modal"
      title="Message"
      :header-text-variant="headerTextVariant"
      hide-footer
    >
      <!-- Body -->
      <div class="row odd-row">
        <div class="col-md-12 row-value">
          <p style="margin: 0; word-wrap: break-word; white-space: pre-wrap; line-height: 1.6;">
            {{ selectedMessageForDisplay }}
          </p>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import api from "@/api/giftcard.js";
import apiuser from "@/api/user.js";
import { HourGlass } from "vue-loading-spinner";
import moment from "moment";
import { amountDecimalNumberFormatter } from "@/utils/formatters.js";

export default {
  name: "GiftCardIssuanceReport",
  components: {
    HourGlass,
  },
  data() {
    const today = moment().format('YYYY-MM-DD');
    const sevenDaysAgo = moment().subtract(7, 'days').format('YYYY-MM-DD');

    return {
      headerTextVariant: "light",
      loading: false,
      storeList: [],
      selectedStore: null,
      today: today,
      filters: {
        fromDate: sevenDaysAgo,
        toDate: today,
      },
      selectedMessageForDisplay: '',
    };
  },
  mounted() {
    this.loadStores();
    document.title = "CanPay - Gift Card Issuance Report";
  },
  methods: {
    loadStores() {
      var self = this;
      self.loading = true;
      apiuser
        .getStores()
        .then((response) => {
          if (response.code == 200) {
            self.storeList = response.data;
            // Auto-select if only one store
            if (self.storeList.length === 1) {
              self.selectedStore = self.storeList[0];
              self.loadDT();
            }
            self.loading = false;
          } else {
            window.error(response.message);
            self.loading = false;
          }
        })
        .catch((err) => {
          window.error(err);
          self.loading = false;
        });
    },
    isDateRangeValid() {
      const fromDate = moment(this.filters.fromDate);
      const toDate = moment(this.filters.toDate);
      const daysDiff = toDate.diff(fromDate, 'days');

      // Check if date range is valid (max 30 days)
      return daysDiff >= 0 && daysDiff <= 30;
    },
    onStoreSelect(store) {
      // if (store) {
      //   this.loadDT();
      // }
    },
    reloadDatatable() {
      var self = this;
      if (!self.isDateRangeValid()) {
        window.error("Date range cannot exceed 30 days");
        return;
      }

      if ($.fn.DataTable.isDataTable("#giftCardIssuanceTable")) {
        $("#giftCardIssuanceTable").DataTable().ajax.reload();
      } else {
        self.loadDT();
      }
    },
    loadDT() {
      var self = this;
      if (!self.selectedStore) return;
      if (!self.isDateRangeValid()) {
        window.error("Date range cannot exceed 30 days");
        return;
      }

      if ($.fn.DataTable.isDataTable("#giftCardIssuanceTable")) {
        $("#giftCardIssuanceTable").DataTable().destroy();
      }

      // Remove any existing event handlers to prevent duplicates
      $(document).off('click', '.show-more-link');

      // Add event handler for show more links
      $(document).on('click', '.show-more-link', function(e) {
        e.preventDefault();
        const message = $(this).data('message');
        self.showMessageModal(message);
      });

      $("#giftCardIssuanceTable").DataTable({
        pagingType: "simple_numbers",
        processing: true,
        serverSide: true,
        destroy: true,
        columnDefs: [
          { orderable: false, targets: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] },
          { className: "dt-left", targets: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10] }
        ],
        order: [[0, "desc"]],
        orderClasses: false,
        language: {
          processing:
            '<i class="fa fa-spinner fa-spin fa-3x fa-fw"></i><span class="sr-only">Loading...</span> ',
          emptyTable: "No Purchase History Available.",
          search: "_INPUT_",
          searchPlaceholder: "Search records",
          oPaginate: {
            sNext: '<i class="fas fa-angle-double-right"></i>',
            sPrevious: '<i class="fas fa-angle-double-left"></i>',
          },
          sLengthMenu:
            "<label class='label_dropdown_dt'>Per page</label> _MENU_",
        },
        ajax: {
          headers: {
            Authorization: localStorage.getItem("token"),
          },
          url: process.env.VUE_APP_API_URL + "/merchant/giftcard/history",
          type: "GET",
          dataType: "json",
          data: function (d) {
            // Convert DataTable parameters to backend expected format
            d.draw = d.draw || 1;
            d.start = d.start || 0;
            d.length = d.length || 10;
            if (d.search && d.search.value) {
              d['search.value'] = d.search.value;
            }
            d.store_id = self.selectedStore.id;
            d.from_date = self.filters.fromDate;
            d.to_date = self.filters.toDate;
            return d;
          },
          dataSrc: function (result) {
            return result.data;
          },
          error: function (request) {
            if (
              request.responseJSON &&
              request.responseJSON.code == 401 &&
              request.responseJSON.data != null
            ) {
              localStorage.setItem("token", request.responseJSON.data);
              self.loadDT();
            } else {
              window.error("Failed to load gift card issuance data");
              $('#giftCardIssuanceTable_processing').hide();
            }
          },
        },
        columns: [
          {
            render: function (data, type, full, meta) {
              return new Date(full.purchase_date).toLocaleDateString() + ' ' +
                     new Date(full.purchase_date).toLocaleTimeString();
            }
          },
          { data: "store_name" },
          {
            render: function (data, type, full, meta) {
              const deliveryType = full.delivery_type || 'digital';
              if (deliveryType === 'printable') {
                return '<span class="badge badge-info"><i class="fas fa-ticket-alt mr-1"></i>Print Code</span>';
              } else {
                return '<span class="badge badge-primary"><i class="fas fa-envelope mr-1"></i>Email</span>';
              }
            }
          },
          {
            render: function (data, type, full, meta) {
              return full.reference_number || 'N/A';
            }
          },
          { data: "sender_name" },
          {
            render: function (data, type, full, meta) {
              return full.recipient_name || '';
            }
          },
          {
            render: function (data, type, full, meta) {
              return full.recipient_phone || '';
            }
          },
          {
            render: function (data, type, full, meta) {
              return full.recipient_email || '';
            }
          },
          {
            render: function (data, type, full, meta) {
              return '$' + amountDecimalNumberFormatter(full.amount);
            }
          },
          {
            render: function (data, type, full, meta) {
              // Show redeemed date for coupon-based cards, delivery date for Email/SMS cards
              if (full.delivery_type === 'printable') {
                 if (full.redeemed_at) {
                  return new Date(full.redeemed_at).toLocaleDateString();
                } else {
                  return 'N/A';
                }
              }
              if (full.scheduled_sharing_date) {
                return new Date(full.scheduled_sharing_date).toLocaleDateString();
              }
              return 'N/A';
            }
          },
          {
            render: function (data, type, full, meta) {
              const message = full.message || '';
              if (message.length > 40) {
                const truncated = message.substring(0, 40) + '...';
                return truncated + ' <a href="#" class="show-more-link" data-message="' +
                       message.replace(/"/g, '&quot;') + '">show more</a>';
              }
              return message;
            }
          }
        ],
      });

    },

    // ✅ Format amount with 2 decimal places
    amountDecimalNumberFormatter(val) {
      return amountDecimalNumberFormatter(val);
    },

    // ✅ Show Message Modal
    showMessageModal(message) {
      this.selectedMessageForDisplay = message;
      this.$refs['message-display-modal'].show();
    },

    // ✅ Hide Message Modal
    hideMessageModal() {
      this.$refs['message-display-modal'].hide();
      this.selectedMessageForDisplay = '';
    },
  },
};
</script>

<style scoped>
.loading {
  text-align: center;
  padding: 20px;
}

.table {
  margin-bottom: 0;
}

.table thead th {
  border-bottom: 2px solid #dee2e6;
  font-weight: 600;
}

.table tbody tr:hover {
  background-color: #f5f5f5;
}
</style>

